// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var OAuthController = function ($scope, $http, OAuthGrants, OAuthClients, ThirdPartyIntegrationSettings) {
    // Id corresponds to non-existing entity
    // Value is hard-coded on backend side
    $scope.defaultId = '51011335eb596a0e149f2b26';
    $scope.entityId = null;

    $scope.load = function ()
    {
        $scope.loadClients();
        $scope.grants = OAuthGrants.query();
        $scope.loadExternalProviderAuthenticationSettings();
    }

    $scope.loadClients = function ()
    {
        $scope.clients = OAuthClients.query({entityId:$scope.entityId});
    }
    
    $scope.loadExternalProviderAuthenticationSettings = function (entityId){
        $scope.thirdPartySettings = ThirdPartyIntegrationSettings.externalProviderAuthenticationSettings({entityId: entityId});
    }

    function suspend(id) {
        $http.post('/api/v1/oAuthClients/' + id + '/suspend', {}).success(function () { $scope.load(); });
    }

    function resume(id) {
        $http.post('/api/v1/oAuthClients/' + id + '/resume', {}).success(function () { $scope.loadClients(); });
    }

    $scope.suspend = function (id) {
        $scope.confirm("OAuth Client", "Are you sure you want to suspend this client?", suspend.bind(this, id));
    }

    $scope.resume = function (id) {
        $scope.confirm("OAuth Client", "Are you sure you want to resume this client?", resume.bind(this, id));
    }
    
    function skipLoginPage (id) {
        $http.put('/api/v1/thirdPartyIntegrationSettings/' + id + '/loginPageSkipMarker', {skip : true}).success(function () { $scope.load(); });
    }
    
    function useLoginPage (id) {
        $http.put('/api/v1/thirdPartyIntegrationSettings/' + id + '/loginPageSkipMarker', {skip : false}).success(function () { $scope.load(); });
    }
    
    $scope.skipLoginPage = function(id) {
        $scope.confirm(
            "SSO",
            "Please make sure to only activate this on dedicated systems! Are you sure you want to skip login page for this settings?",
            skipLoginPage.bind(this, id)
        );
    }

    $scope.useLoginPage = function(id) {
        $scope.confirm(
            "SSO",
            "Are you sure you want to use login page for this settings?",
            useLoginPage.bind(this, id)
        );
    }
    
    $scope.load();
};
OAuthController.$inject = ['$scope', '$http', 'OAuthGrants', 'OAuthClients', 'ThirdPartyIntegrationSettings'];
